<section class="health">
    <h1>Messaging Service Health Check</h1>

    <div *ngIf="loading" class="loading">
        <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
        <span>Checking...</span>
    </div>

    <div *ngIf="!loading && result" class="result" [class.ok]="result.ok" [class.fail]="!result.ok">
        <p class="status">
            Status: <strong>{{ result.ok ? 'Healthy' : 'Unhealthy' }}</strong>
            <small>({{ result.httpStatus || 'n/a' }})</small>
        </p>

        <pre class="details">{{ result | json }}</pre>

        <button type="button" (click)="runCheck()">Re-run</button>
    </div>
</section>
